import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { StepButtons } from 'src/modules/programs/components/StepButtons';
import * as S from 'src/modules/programs/stepComponents/styles';

import { PlannedActivity } from '../../weekThree/models/weekThree';
import {
    getPlannedActivities,
    isCheckInAboutPracticeDataValid,
} from '../../weekThree/selectors/weekThreeSelectors';
import { submitFlexibilityHomeworkData } from '../actions/weekFourActions';
import { AreaActivitiesStatus } from '../components/AreaActivitiesStatus';

interface StateProps {
    isDataValid: boolean;
    plannedActivities: PlannedActivity[];
}

interface ActionsProps {
    submitFlexibilityHomeworkData: typeof submitFlexibilityHomeworkData;
}

interface Props extends StateProps, ActionsProps {
    goToPreviousStep: () => void;
    goToNextStep: () => void;
}

class CheckInAboutPracticeStepContainer extends React.Component<Props> {
    private handleSubmit = () => {
        if (!this.props.isDataValid) {
            return;
        }

        this.props.submitFlexibilityHomeworkData(this.props.plannedActivities);
        this.props.goToNextStep();
    };

    public render(): JSX.Element {
        const { isDataValid, plannedActivities } = this.props;

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn>
                        <S.StepHeading small>Check in about homework:</S.StepHeading>
                        <S.StepHeading>What actions did you do last week?</S.StepHeading>
                        <S.StepDescription small>
                            Last week, you selected the following things to do to live more
                            according to your values. Were you able to do them? Check off the ones
                            you completed and how you felt doing it.
                        </S.StepDescription>
                        {plannedActivities.map(activity => (
                            <AreaActivitiesStatus activity={activity} key={activity.title} />
                        ))}
                    </S.ContentColumn>
                </S.ContentRow>
                <StepButtons
                    onPreviousClick={this.props.goToPreviousStep}
                    onNextClick={this.handleSubmit}
                    nextDisabled={!isDataValid}
                    hasNextStep
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    isDataValid: isCheckInAboutPracticeDataValid(state),
    plannedActivities: getPlannedActivities(state),
});

export const CheckInAboutPracticeStep = connect(mapStateToProps, { submitFlexibilityHomeworkData })(
    CheckInAboutPracticeStepContainer,
);
